import { render, staticRenderFns } from "./UnitTranslationTable.vue?vue&type=template&id=46168235&scoped=true&"
import script from "./UnitTranslationTable.vue?vue&type=script&lang=js&"
export * from "./UnitTranslationTable.vue?vue&type=script&lang=js&"
import style0 from "./UnitTranslationTable.vue?vue&type=style&index=0&id=46168235&prod&lang=css&"
import style1 from "./UnitTranslationTable.vue?vue&type=style&index=1&id=46168235&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46168235",
  null
  
)

export default component.exports